import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	mobileMainContainer: {

	},
	liveText: {
		fontWeight : "500",
		fontSize   : "1.8rem",
		margin     : "1rem 2rem"
	},
	listContainer: {
		marginBottom: "70px"
	}
} ), { name: "mobile-live-page" } );
